import React from 'react'
import FontAwesome from 'react-fontawesome'
import styled from 'styled-components'
import { BLUE } from '../../styles/colors.style'
import { breakpoints } from '../../constants'
import { isMobile } from '../../helpers'

const StyledBackdrop = styled.div`
	position: fixed;
	background: rgba(0, 0, 0, 0.5);
	left: 0;
	top: 0;
	height: 100vh;
	width: 100vw;
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 4;

	@media screen and (min-width: 480px) {
		justify-content: center;
	}
`

const getWidth = ({ medium, large }) =>
	medium ? '600px' : large ? '900px' : 'auto'

const getPadding = ({ noPadding }) =>
	noPadding
		? ``
		: `
		background: #fff;
		padding: 25px;
		overflow: auto;
		`

const StyledModal = styled.div`
	${getPadding}
	width: calc(100% - 30px);
	border-radius: 5px;
	position: relative;
	box-sizing: border-box;
	max-height: calc(100vh - 70px);

	@media screen and (min-width: 480px) {
		min-width: 300px;
		max-width: ${({ large }) => (large ? '900px' : '700px')};
		max-height: calc(100vh - 80px);
		width: ${getWidth};
	}

	${({ mobileFullWidth }) => (mobileFullWidth ? 'width: 100%;' : '')}

	.title {
		margin-bottom: 3rem;
		padding-top: 2rem;
		line-height: 1em;
	}

	.modal-content {
		font-size: 1.8rem;

		.row {
			height: ${isMobile() ? 6 : 3}em;
			align-items: center;
			margin: 0;
		}

		button {
			font-size: ${isMobile() ? 1.4 : 1}em;
		}

		textarea {
			width: 100%;
		}

		@media screen and (max-width: ${breakpoints.PHONE_LARGE}) {
			width: 260px;
		}
	}

	.fa-close {
		color: ${BLUE};
		position: absolute;
		right: ${({ noPadding }) => (noPadding ? '-15px' : '15px')};
		top: ${({ noPadding }) => (noPadding ? '-20px' : '13px')};
		cursor: pointer;

		@media screen and (min-width: ${breakpoints.MOBILE}px) {
			right: ${({ noPadding }) => (noPadding ? '-15px' : '5px')};
			top: ${({ noPadding }) => (noPadding ? '-20px' : '0px')};
		}

		@media screen and (max-width: ${breakpoints.PHONE_LARGE}px) {
			right: 5px;
		}

		&:before {
			-webkit-text-stroke: 4px #fff;
		}
	}

	@media screen and (min-width: ${breakpoints.MOBILE}px) {
		width: initial;
	}
`

/**
 * Modal component
 * @param {boolean} noPadding Removes padding of modal
 *
 * @param {string} animation The modal opening transition (Animated.css)
 *
 */
export class Modal extends React.Component {
	constructor(props) {
		super(props)
		this.props = props
		this.state = {
			fade: false,
			animate: false,
		}
	}

	close = () => {
		this.setState({ fade: true })
		setTimeout(() => {
			this.props.onClose && this.props.onClose()
			this.setState({ fade: false })
		}, 500)
	}

	componentWillReceiveProps({ isOpen }) {
		if (!this.props.isOpen && isOpen) {
			this.setState({ animate: true })
			setTimeout(() => {
				this.setState({ animate: false })
			}, 1000)
		}
	}

	getBackDropClass = () => (this.state.fade ? 'animated fadeOut' : '')

	getOpenClass = (animation) =>
		this.state.animate
			? !!animation
				? `animated ${animation}`
				: 'animated slideInDown'
			: ''

	render() {
		const { large, medium, animation, noPadding, mobileFullWidth } =
			this.props
		return this.props.isOpen ? (
			<StyledBackdrop
				className={`${this.getBackDropClass()} modal-opened`}
				onClick={() => this.close()}>
				<StyledModal
					large={large}
					medium={medium}
					noPadding={noPadding}
					mobileFullWidth={mobileFullWidth}
					onClick={(e) => e.stopPropagation()}
					className={this.getOpenClass(animation)}>
					<div>
						{this.props.title ? (
							<div className="title">{this.props.title}</div>
						) : null}
						<FontAwesome name="close" size="3x" onClick={this.close} />
						<div className="modal-content">{this.props.children}</div>
					</div>
				</StyledModal>
			</StyledBackdrop>
		) : null
	}
}

export default Modal
